import api from "@/api/url";

export default {
    namespaced: true,

    state: () => {
        return {
            systemPlans: {},
            integrations: [],
        };
    },

    getters: {
        systemPlans: state => state.systemPlans,
        integrations: state => state.integrations,
    },

    mutations: {
        set(state, [key, value]) {
            state[key] = value;
        },
    },
    
    actions: {
        fetchSystemPlans({ commit, state }) {                                    
            if (Object.keys(state.systemPlans).length) {
                return;
            }

            return api.config.getAccountPlans()
                .then((resp) => {
                    const data = resp?.data?.data;
                    commit("set", ["systemPlans", data]);
                });
        },

        fetchSystemIntegrations({ commit, state }, { params, refresh }) {                                    
            if (state.integrations.length && !refresh) return;

            return api.config.getIntegrations(params)
                .then((resp) => {
                    const data = resp?.data?.data;                    
                    commit("set", ["integrations", data]);
                });
        },
    },
};